import {notice} from "../UI/notice";
import Agent from "../Core/agent";
import {parseHTML} from "../Core/common";

import Swiper, {Navigation} from 'swiper';
import Choices from "choices.js";


const compare = new Map(Object.entries(JSON.parse(localStorage.getItem('compare') || '{}')));
const compareLink = document.querySelector('.js_compare_link');
function setTotalCompare() {
    let totalCount = 0;
    compare.forEach(values => {
        totalCount += values.length;
    });
    document.querySelectorAll('.js_total_count_compare').forEach(item => {
        item.classList.remove('preloader');
        item.innerHTML = totalCount;
    });

    // if(totalCount && compareLink){
    //     compareLink.classList.add('active');
    // }else if(compareLink){
    //     compareLink.classList.remove('active');
    // }
}

function removeOptionsByValue(selectBox, value)
{
    for (let i = selectBox.length - 1; i >= 0; --i) {
        if (selectBox[i].value === value) {
            selectBox.remove(i);
        }
    }
}

setTotalCompare();

const compareEvent = (item, id, type) => {
    item.addEventListener('click', () => {
        let items = compare.get(type) || [];
        let index = items.indexOf(id);

        if (index >= 0) {
            items.splice(index, 1);
            notice('Удален из сравнения');
            document.querySelectorAll(`.js_add_compare[data-id="${id}"]`).forEach(item => {
                item.classList.remove('active');
                item.title = 'Добавить в избранное';
            });

        } else {
            items.push(id);
            notice('Добавлен в сравнение');
            document.querySelectorAll(`.js_add_compare[data-id="${id}"]`).forEach(item => {
                item.title = 'Удалить из сравнения';
                item.classList.add('active');
            });
        }

        compare.set(type, items);
        setTotalCompare();
        localStorage.setItem('compare', JSON.stringify(Object.fromEntries(compare.entries())));
    });
};

const removeBlock = element => {
    element.remove();
    if (!document.querySelector('.js_load_compare')) {
        document.querySelector('.section.compare').classList.remove('d-none');
    }
};

const tabInit = item => {

    function compare (){
        const liAutoHeight = () => {
            let map = new Map();
            document.querySelectorAll('.compare-table__value').forEach(item => {
                let parameterId = item.dataset.parametr;
                let t = map.get(parameterId) || [];
                t.push(Math.floor(parseFloat(getComputedStyle(item).height) || 0))
                map.set(parameterId, t)
            })
            let keys = Array.from(map.keys());
            keys.map(item => {
                let arr = map.get(item);
                let max = Math.max(...arr);
                document.querySelectorAll(`.compare-table__value[data-parametr="${item}"]`).forEach(i => {
                    if (max > 0) {
                        i.style.height = max + 'px';
                    }
                })
            })
        }
        liAutoHeight();
        window.addEventListener('resize', function(){
            liAutoHeight();
        })
    }
    compare ();
    document.querySelector('.diff-compare').addEventListener('change', (event)=> {
        if(event.target.checked){
            document.querySelectorAll('.compare-table__row[data-diff="1"]').forEach(item => {
                item.style.display = "none";
            });
        } else {
            document.querySelectorAll('.compare-table__row').forEach(item => {
                item.style.display = "flex";
            })
        }
    })
    function selected(){
        document.querySelector('[name="compare-block"]').addEventListener('change', (event) => {
            let currentValue = event.target.value;
            document.querySelectorAll('.slider-compare').forEach(item => {
                item.style.display = "none";
                if(item.dataset.category === currentValue){
                    item.style.display = "block";

                }
            })
            document.querySelectorAll('.slider-navigation-compare').forEach(item => {
                item.style.display = "none";
                if(item.dataset.category === currentValue){
                    item.style.display = "flex";
                }
            })
        })
    }
    selected();
    document.querySelector('[name="compare-block"]').dispatchEvent(new Event('change'));

};

const deleteItem = (item, swiperCompare) => {
    const id = item.dataset.id;
    const type = item.dataset.type;
    const tabBlock = item.closest('.swiper');
    const block = item.closest('.section');

    //item.closest('.js_item').remove();
    item.closest('.swiper-slide').remove();

    swiperCompare.update();

    let items = compare.get(type) || [];
    let index = items.indexOf(id);

    if (index >= 0) {
        items.splice(index, 1);
        notice('Удален из сравнения');

        compare.set(type, items);
        setTotalCompare();
        localStorage.setItem('compare', JSON.stringify(Object.fromEntries(compare.entries())));

        if (tabBlock) {
            //const currentTab = tabBlock.querySelector('.custom-tab.active');
            //let article = currentTab.dataset.tab;

            //let currentTabContent = tabBlock.querySelector(`.js_custom-item[data-tab="${article}"]`);
            //let curr = tabBlock.querySelector(`.custom-item[data-tab="${article}"]`);
            if (!tabBlock.querySelector('.js_item')) {
                let category = tabBlock.dataset.category;
                tabBlock.remove();

                let sliderPaginationCompare = document.querySelector(`.slider-pagination-compare[data-category="${category}"]`);
                if(sliderPaginationCompare){
                    sliderPaginationCompare.remove();
                }

                let compareSelect = document.querySelector('[name="compare-block"]');
                removeOptionsByValue(compareSelect, category);
                if (compareSelect && (compareSelect.options[0] || false)) {
                    compareSelect.selectedIndex = 0;
                    let event = new Event("change");
                    compareSelect.dispatchEvent(event);
                } else {
                    removeBlock(block);
                }
            }
        } else {
            if (!block.querySelector('.js_item')) {
                removeBlock(block);
            }
        }
    }
};

export const compareInit = (selector, events) => {

    document.querySelectorAll(selector).forEach(item => compareInitItem(item));

    document.querySelectorAll('.js_load_compare').forEach(item => {
        let type = item.dataset.type;
        let items = compare.get(type);
        if (items && items.length) {
            Agent.post(`/compare/${type}.html`, JSON.stringify(items), {
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(e => e.json())
                .then(e => {
                    item.classList.remove('preloader');
                    if (e.success) {
                        item.append(parseHTML(e.data));
                        new Choices(".js-choice", {
                            itemSelectText: '',
                            position: 'bottom',
                            searchEnabled: false,
                        });
                        tabInit(item);
                        events.dispatch('filter.search');
                        document.querySelectorAll('.slider-compare').forEach(swipers => {
                            let currentCategory = swipers.dataset.category;
                            let currentNavigation = document.querySelector(`.slider-navigation-compare[data-category="${currentCategory}"]`);
                            let navigation = {};
                            if (currentNavigation) {
                                let next = currentNavigation.querySelector('.slider-next');
                                let prev = currentNavigation.querySelector('.slider-prev');
                                navigation = {
                                    nextEl: next,
                                    prevEl: prev,
                                }
                            }
                            let swiperCompare = new Swiper(swipers, {
                                modules: [Navigation],
                                spaceBetween: 10,
                                slidesPerView: 2,
                                navigation: navigation,
                                watchSlidesVisibility: true,
                                slideActiveClass: "active",
                                breakpoints: {
                                    768: {
                                        slidesPerView: 3,
                                    },
                                    1250: {
                                        slidesPerView: 5,
                                    },
                                    1470: {
                                        slidesPerView: 6,
                                    }
                                }
                            })
                            swipers.querySelectorAll('.js_delete_item').forEach(btn => btn.addEventListener('click', deleteItem.bind(null, btn, swiperCompare)));

                        })

                        let compareBlock = document.querySelector('[name="compare-block"]');
                        if (compareBlock) {
                            compareBlock.dispatchEvent(new Event('change'));
                        }
                    } else {
                        removeBlock(item.closest('.section'));
                    }
                })
                .catch(e => console.log(e));
        } else {
            removeBlock(item.closest('.section'));
        }
    });
};

export const compareInitItem = item => {

    if (!item.classList.contains('js_compare_initialized')) {
        item.classList.add('js_compare_initialized');

        const id = item.dataset.id;
        const type = item.dataset.type;

        let items = compare.get(type) || [];
        let index = items.indexOf(id);

        if (index >= 0) {
            item.classList.add('active');
            item.title = 'Удалить из избранного';
        }

        compareEvent(item, id, type);
    }
};